export class Media {

}
